import { render, staticRenderFns } from "./Faq_test.vue?vue&type=template&id=7097d988&scoped=true&"
import script from "./Faq_test.vue?vue&type=script&lang=ts&"
export * from "./Faq_test.vue?vue&type=script&lang=ts&"
import style0 from "./Faq_test.vue?vue&type=style&index=0&id=7097d988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7097d988",
  null
  
)

export default component.exports